import styled, {keyframes, css, FlattenSimpleInterpolation} from 'styled-components'
import {Col, media} from '@modifi/ui'

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`

const fadeInOverlay = keyframes`
  0% {
    transform: translateY(-20%);
    opacity: 0;
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  }

  100% {
    transform: translateY(0%);
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  }
`

const swipeCursor = css`
  animation-name: ${fadeInOverlay};
  animation-fill-mode: forwards;
  animation-duration: 3s;
`

type ImageWrapperProps = {
  hasAnimationForImage: boolean
  isRounded: boolean
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
  ${({hasAnimationForImage}): FlattenSimpleInterpolation | string =>
    hasAnimationForImage ? swipeCursor : ''}
  ${({isRounded}): FlattenSimpleInterpolation | string =>
    isRounded
      ? css`
          overflow: hidden;
          border-radius: 8px;
          ${media.min.lg`
            border-radius: 24px;
          `}
        `
      : ''}
`

export const ImageCol = styled(Col)`
  align-items: center;
`
export const Video = styled.video`
  object-fit: cover;
  height: 100%;
`
